module.exports = __webpack_public_path__ + "static/img/__7888.311839f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__7888.jpg
// module id = /7v/
// module chunks = 0